import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const messageService = inject(MessageService);

  if (!keycloak.isLoggedIn()) {
    return next(req);
  }

  return from(keycloak.getToken()).pipe(
    switchMap(token => {
      const finalReq = token ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      }) : req;

      return next(finalReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 403) {
            messageService.add({
              severity: 'error',
              summary: 'Acesso Negado',
              detail: 'Você não tem permissão para realizar esta ação.',
              life: 5000
            });
          }
          return throwError(() => error);
        })
      );
    })
  );
};
